import { API_URL } from '../../../app-config/constants';
import { get } from '../request';

const ENTRY = `${API_URL}`;

export function intercomContactExists(): Promise<boolean> {
    return get(`${ENTRY}/intercom-contact`);
}
